const userStatus = {
    Inactive: 'Inactive',
    InviteSent: 'Invite Sent',
    Active: 'Active',
};

export default userStatus;
